<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Multiselect from "@vueform/multiselect";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxSummary,
  DxTotalItem,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter

} from 'devextreme-vue/data-grid';
import moment from "moment/moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxDataGrid, DxColumn, DxButton,
    DxColumnChooser, DxColumnFixing, DxSelection, DxExport, DxSummary, DxTotalItem, DxStateStoring, DxGroupPanel, DxGrouping,
    DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter, Multiselect
  },

  data() {

    return {
      title: "Cotações",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Cotações",
          active: true
        }
      ],
      dataList: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
      showMovalAssocMov: false,
      idMovAssoc: 0,
      dtListPesqMov: null,
      idsAtualizar: null,
      userPct: null,
      empresaPct: null,
      totaisPct: null,
      userLogged: {},

    };
  },

  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted cotafrt-list_0')
    this.atualizaDataList()
  },


  methods: {

    upgradePlano(){
      console.log('upgradePlano')
      this.$router.push('/usuario/perfil/' + this.userLogged.id)
    },

    pesqMovimento(evt){
      console.log('pesqMovimento')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/movpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqMov = res.data
        });
      }
    },


    assocMov(){
      console.log('assocMov')
      console.log(this.dataGrid.getSelectedRowsData())
      this.idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(this.idsAtualizar)
      console.log(this.idsAtualizar.length)
      if (this.idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhuma cotação foi selecionada, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.showMovalAssocMov = true
      }
    },



    confirmarAssocMov(){
      console.log('confirmarAssocMov')
      this.showMovalAssocMov = false
      this.updating = true
      console.log('vai Atualizar')
      api.get(`${getBaseUrl()}api/cotafrtasmov`,{
        params: {
          'ids': this.idsAtualizar,
          'idmov': this.idMovAssoc
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento(s) processado(s) com sucesso!",
          text: response.data,
          showConfirmButton: false,
          timer: 3500
        }).then(() => {
          location.reload()
        })
        this.updating = false
      })
    },


    abrirCotaInterna(){
      console.log('abrirCotaInterna')
      const routeData = this.$router.resolve(`/cotafrts/listinterna`)
      window.open(routeData.href, '_blank')
    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_cota_0')
      api.get(`${getBaseUrl()}api/userpct`, {
        params: {
          'tabela': 'cotacao'
        }
      }).then(response => {
        console.log('response.userpct')
        console.log(response)
        this.userPct = response.data[0]
        this.empresaPct = response.data[1]
        this.totaisPct = response.data[2]
      })


      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "cotafrt_id",
        load: function(loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }
          return api.get(`${getBaseUrl()}api/cotafrtsnova`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Cotações: ${dtIniFormated} - ${dtFimFormated}`

    },

    onCellPrepared(e) {
      if (e.rowType === "data" && e.data.cotafrt_status === 'CO') {
        e.cellElement.style.cssText = `color: white; background-color:  #34c18e; text-aling: center;`
        return 'valor-frete-notnull';
      } else if (e.rowType === "data" && e.data.cotafrt_status === 'CA') {
        e.cellElement.style.cssText = `color: white; background-color:  #f26e41; text-aling: center;`
        return 'valor-frete-notnull';
      } else if (e.rowType === "data" && e.data.cotafrt_status === 'AB') {
        e.cellElement.style.cssText = `color: black; background-color:  white; text-aling: center;`
        return 'valor-frete-notnull';
      }
    },


    novaCotacao(){
      console.log('novaCotacao')
      console.log(this.userPct)
      if (this.userPct && this.totaisPct && this.totaisPct.tabs === 0 && this.totaisPct.tokens === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhuma tabela ou token definido, favor cadastrar tabela ou token antes solicitar de qualquer cotação.",
          showConfirmButton: true,
          confirmButtonText: "Acessar Tabelas"
        }).then((selected) => {
          if (selected.isConfirmed) {
            this.$router.push({path: "/cotacaofretesbase/list", force: true })
          }
        })
      } else {
        this.$router.push({path: "/cotafrt/editar/0", force: true })
      }
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.$router.push(`/cotafrt/editar/${idData}`)
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },


    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDecimalSeis(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 6});
      }
      return 0.00;
    },

    frtRuleFormat(e) {
      const values = {
        API_MIN_PRC: 'Retornar cotação com menor preço (API)',
        API_MIN_PRZ: 'Retornar cotação com menor prazo (API)',
        API_MIN_PRZ_TOL: 'Retornar cotação com menor prazo -> x dias de tolerância (API)',
        API_MIN_PRC_TOL: 'Retornar cotação com menor prazo -> % tolerância sobre valor (API)',
      }
      return values[e.value] || e.value;
    },
  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <b-alert show dismissible
             v-if="userPct && userPct.id > 0 && dataList"
             :variant="userPct.limite - userPct.consumo <= 10 ? 'danger' : userPct.limite - userPct.consumo <= 50 ? 'warning' : 'info'">
      <a class="dropdown-item "
         @click="upgradePlano"
         href="javascript: void(0);">
        <i class="mdi mdi-alert me-2"></i>Plano atual consumindo {{ userPct.consumo }} unidade(s) das {{ userPct.limite }} contratada(s), <span class="text-warning">clique aqui e faça upgrade agora mesmo.<i class="mdi mdi-rocket-launch ms-2"></i> </span>
      </a>
    </b-alert>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="belloutline"
              hint="Associar a Movimento"
              :on-click="assocMov"/>
        </DxItem>

        <DxItem
            location="before "
            widget="dxButton">

          <DxButton
              text="Nova Cotação"
              style="background-color: #34c38f; color: white;"
              hint="Nova Cotação"
              :on-click="novaCotacao"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              text="Cotações Detalhadas"
              style="background-color: #c37434; color: white;"
              hint="Cotações Detalhadas"
              :on-click="abrirCotaInterna"/>
        </DxItem>


        <DxItem
            location="center"
            locate-in-menu="never">
          <div class="toolbar-label">Listagem de <b>{{ this.title }}</b></div>
        </DxItem>

      </DxToolbar>

    </div>


    <div class="mt-2">

      <DxDataGrid

          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          style="text-align: center"
          @cell-prepared="onCellPrepared"
          @content-ready="carregouGrid"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strCotarFrtList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn :width="80"
                  sort-order="desc"
                  data-field="cotafrt_id"
                  caption="ID"
                  alignment="right"
                  data-type="number"
                  :fixed="true"
                  fixed-position="left"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn :width="80"
                  data-field="cotafrt_codigo"
                  caption="Código"
                  alignment="right"
                  data-type="text"
                  :fixed="true"
                  fixed-position="left"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            :width="330"
            caption="Segmento"
            alignment="center"
            :allowHeaderFiltering="true">

            <DxColumn :width="80"
                    data-field="cotafrt_segto"
                    caption="Codigo"
                    alignment="left"
                    data-type="number"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true">
            </DxColumn>

            <DxColumn
                :width="80"
                data-field="fretecota_nome"
                alignment="left"
                caption="Nome"
                data-type="text"
                :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                :allowHeaderFiltering="true"/>

        </DxColumn> 

        <DxColumn
            :width="80"
            data-field="cotafrt_tipo"
            alignment="left"
            caption="Tipo"
            data-type="text"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="100"
            data-field="cotafrt_created_at"
            caption="Data"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="100"
            data-field="cotafrt_dtcontr"
            caption="Contratado"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="330"
            caption="Origem"
            alignment="center"
            :allowHeaderFiltering="true">

          <DxColumn
              :width="80"
              data-field="cotafrt_cepori"
              alignment="left"
              caption="CEP"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

        <DxColumn
              :width="80"
              data-field="cotafrt_ufori"
              alignment="left"
              caption="UF"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              :width="80"
              data-field="cotafrt_cidori"
              alignment="left"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Destino"
            alignment="center"
            :allowHeaderFiltering="true">

          <DxColumn
              data-field="cotafrt_cepdest"
              alignment="left"
              caption="CEP"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="cotafrt_ciddest"
              alignment="left"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

            <DxColumn
              data-field="cotafrt_ufdest"
              alignment="left"
              caption="UF"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="cotafrt_cnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="cotafrt_nome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Transportadora"
            alignment="center"
            :allowHeaderFiltering="true">

          <DxColumn
              data-field="cotafrt_cnpjtransp"
              alignment="left"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="cotafrt_nometransp"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

        </DxColumn>


        <DxColumn
            caption="Nota Fiscal"
            alignment="center"
            :allowHeaderFiltering="true">
          <DxColumn
              data-field="cotafrt_numnf"
              alignment="left"
              caption="Número"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>
          <DxColumn
              data-field="cotafrt_pesonf"
              caption="Peso"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>
          <DxColumn
              data-field="cotafrt_valornfxml"
              caption="Valor"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>
        </DxColumn>


        <DxColumn
            caption="CT-e"
            alignment="center"
            :allowHeaderFiltering="true">
          <DxColumn
              data-field="cotafrt_numcte"
              alignment="left"
              caption="Número"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>
          <DxColumn
              data-field="cotafrt_pesocte"
              caption="Peso"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>
          <DxColumn
              data-field="cotafrt_valorcte"
              caption="Valor"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>
          <DxColumn
              data-field="cotafrt_valorcgcte"
              caption="Valor Carga"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>
        </DxColumn>

        <DxColumn
            data-field="cotafrt_peso"
            :format="formatDecimal"
            caption="Peso"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="cotafrt_pesobscalc"
            :format="formatDecimal"
            caption="Peso BS.Calc."
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="cotafrt_valornf"
            alignment="right"
            :fixed="true"
            caption="Valor NF"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">

        </DxColumn>

        <DxColumn
            data-field="cotafrt_valorfrete"
            alignment="right"
            :fixed="true"
            caption="Valor Frete"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="cotafrt_dimens"
            alignment="right"
            :fixed="true"
            caption="T.Dimens."
            :format="formatDecimalSeis"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true">
        </DxColumn>

        
        <DxColumn
            :width="330"
            caption="Frete Regras"
            alignment="right"
            :allowHeaderFiltering="true">

            <DxColumn
              data-field="cotafrt_regra"
              alignment="left"
              caption="Regra"
              data-type="text"
              :allowHeaderFiltering="false"
              :customize-text="frtRuleFormat"
            />

            <DxColumn
              data-field="cotafrt_rgtrnome"
              alignment="left"
              caption="Transp. Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            />

            <DxColumn
              data-field="cotafrt_rgtrcnpj"
              alignment="left"
              caption="Transp. CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            />
  
          <DxColumn
              data-field="cotafrt_rgprazo"
              caption="Prazo"
              data-type="number"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>
  
          <DxColumn
              data-field="cotafrt_rgvalor"
              caption="Valor"
              data-type="number"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"
              :format="formatDecimal"/>

        </DxColumn>

        <DxSummary>

          <DxTotalItem
              column="OrderNumber"
              summary-type="count"/>

          <DxTotalItem
              column="OrderDate"
              summary-type="min"/>

          <DxTotalItem
              column="OrderDate"
              summary-type="max"/>


          <DxTotalItem
              column="SaleAmount"
              summary-type="sum"
              value-format="currency"/>

        </DxSummary>



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal title="Associar Coletas a Movimento"
             size="lg"
             v-model="showMovalAssocMov"
             centered hide-footer>

      <div class="row">
        <div class="col-lg-12">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <p class="text-muted mb-2"> Cotações a associar:</p>
                  <h5 class="mb-0"> {{ idsAtualizar }} </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">

          <div class="mb-3">
            <span>Selecionar Movimento ID: {{ idMovAssoc }}</span>

            <multiselect id="inputRomaneio"
                         @search-change="pesqMovimento"
                         v-model="idMovAssoc"
                         placeholder="Pesquisar movimento"
                         :options="dtListPesqMov"
                         :searchable="true"
                         label="codigo"
                         track-by="codigo"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.codigo }}
                    </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.destnome }}</div>
                  <div class="align-items-end text-end align-content-end">{{ slotProps.option.destcnpj }}</div>
                </div>
              </template>
            </multiselect>

          </div>

          <div class="text-end mt-5">


            <b-button variant="light" @click="showMovalAssocMov = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>


            <!--          <b-button variant="outline-success" @click="confirmarAssocRomaNovo">-->
            <!--            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
            <!--            Criar e Associar a Novo Romaneio-->
            <!--          </b-button>-->

            <b-button :disabled="idMovAssoc === 0"
                      type="submit" variant="success" class="ms-1" @click="confirmarAssocMov()">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>

          </div>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>